import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQueryClient, useMutation } from 'react-query';

function useReplyToDoubt() {
  const { privateFetch } = useContext(FetchContext);
  const queryClient = useQueryClient();

  const replyToDoubt = async ({ discussionId, answer, answerImage, answerImageFullPath }) => {
    const payload = {
      answer,
      ...(answerImage && { image: answerImage }),
      ...(answerImageFullPath && { imageFullPath: answerImageFullPath }),
    };
    const res = await privateFetch.put(`/v1/admin/doubts/${discussionId}/reply`, payload);
    return res;
  };

  return useMutation(replyToDoubt, {
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries('doubts');
    },
    onError: (err) => {
      console.error('Reply failed:', err);
    },
  });
}

export default useReplyToDoubt;
